import classNames from "classnames";
import React from "react";
import styles from "./dotIndicator.css";

type Variant = "alert" | "presence";
interface Props {
  className?: string;
  variant: Variant;
}
export const DotIndicator = ({ variant, className }: Props) => (
  <div
    className={classNames(styles.indicator, className, {
      [styles["variant-alert"]]: variant === "alert",
      [styles["variant-presence"]]: variant === "presence"
    })}
  />
);
